import { Field, Popup, CheckboxGroup, Checkbox, CellGroup, Cell } from "vant"
import { computed, defineComponent, ref, withModifiers } from "vue"
import classes from "./index.module.less"

export default defineComponent({
  name: "MultiplePicker",
  props: {
    modelValue: { type: Array, default: () => [] },
    columns: { type: Array, default: () => [] },
    placeholder: String,
    disabled: Boolean,
    title: String,
    config: { type: Object, default: () => ({}) }
  },
  emits: ["update:modelValue"],
  setup(props, { attrs, emit, slots }) {
    const visible = ref(false)

    const modelValue = computed({
      get() {
        return props.modelValue
      },
      set(value) {
        emit("update:modelValue", value)
      }
    })

    const insideValue = ref([])

    const columnsFieldNames = computed(() => {
      const { columnsFieldNames } = props.config
      return {
        text: "text",
        values: "values",
        children: "children",
        value: "value",
        ...columnsFieldNames
      }
    })

    const checkedColumns = computed(() => {
      const { columns } = props
      const { value: valueKey } = columnsFieldNames.value
      return columns.filter(({ [valueKey]: id }) => {
        return modelValue.value.includes(id)
      })
    })

    const popupProps = computed(() => {
      return {
        round: true,
        closeOnPopstate: true,
        position: "bottom",
        teleport: "body"
      }
    })

    const showValue = computed(() => {
      const { text } = columnsFieldNames.value
      return checkedColumns.value.map((item) => item[text])
    })

    const show = () => {
      if (!props.disabled) {
        visible.value = true
        insideValue.value = modelValue.value
      }
    }
    const close = () => {
      visible.value = false
    }
    const commit = () => {
      visible.value = false
      modelValue.value = insideValue.value
    }

    const fieldProps = computed(() => {
      return {
        readonly: true,
        disabled: props.disabled,
        rightIcon: props.disabled ? "" : "arrow",
        placeholder: props.placeholder,
        class: [classes.input],
        modelValue: showValue.value.join("，")
      }
    })
    const renderField = () => {
      if (slots.field) return slots.field(showValue.value)
      else {
        return <Field {...fieldProps.value} />
      }
    }

    const useToggle = (i) => {
      return () => {
        refs.value[i].toggle()
      }
    }
    const refs = ref([])
    const itemRenderer = () => {
      const { text: textKey, value: valueKey } = columnsFieldNames.value
      return props.columns.map((item, i) => {
        const { [textKey]: label, [valueKey]: value } = item
        return (
          <Cell
            clickable
            key={value}
            title={label}
            onClick={useToggle(i)}
            vSlots={{
              "right-icon": () => {
                return (
                  <Checkbox
                    name={value}
                    ref={(el) => (refs.value[i] = el)}
                    onClick={withModifiers(() => {}, ["stop"])}
                  />
                )
              }
            }}
          />
        )
      })
    }

    return () => [
      <div class={["grow-1", attrs.class]} onClick={show}>
        {renderField()}
      </div>,
      <Popup vModel:show={visible.value} {...popupProps.value}>
        <div class={classes.popupMain}>
          <div class={classes.popupTool}>
            <div class={classes.close} onClick={close}>
              取消
            </div>
            <div class={classes.commit} onClick={commit}>
              确认
            </div>
          </div>
          <div class={classes.scrollMain}>
            <CheckboxGroup vModel={insideValue.value}>
              <CellGroup inset>{itemRenderer()}</CellGroup>
            </CheckboxGroup>
          </div>
        </div>
      </Popup>
    ]
  }
})
